module.exports = __webpack_public_path__ + "img/route_pin.0ed51e64.svg";